import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
export function WhyUs() {
  const t = useT();
  return <section className="py-12 md:py-16 dark:bg-[#000000] transition-colors duration-300 border-t border-stone-200 dark:border-[#202020] relative overflow-hidden bg-[#fffff9]" id="why-us" data-id="element-2190" data-mp="17kho7f462ym2">
      {/* Subtle decorative accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-orange/40 to-transparent" data-id="element-2191" data-mp="1gmh4u6b9s0oh" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2192" data-mp="1qibs5eqfujxl">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="grid lg:grid-cols-12 gap-6 lg:gap-12 items-end" data-id="element-2193" data-mp="1qghhqucsma7r">
          <div className="lg:col-span-6" data-id="element-2194" data-mp="3eb1rwdaxkw9t">
            <div className="inline-flex items-center gap-2 mb-3" data-id="element-2195" data-mp="3ec326fk4heqh">
              <MapPin className="w-3.5 h-3.5 text-[#B88F43]" data-id="element-2196" data-mp="3j9d0yltej2qz" />
              <span className="font-bold uppercase tracking-[0.14em] text-[12px] text-[#B88F43]" data-id="element-2197" data-mp="3j7s953yh1xwt">
                {'Local Experts'}
              </span>
            </div>

            <h2 className="text-[40px] sm:text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-stone-900 dark:text-white tracking-tight leading-[1.05]" data-id="element-2198" data-mp="3s2zr9weubdss">
              <span className="font-[Montserrat,_sans-serif] text-[#85A899]" data-id="element-2199" data-mp="5ugodc12ive3">
                We're the dispatcher.
              </span>
              <span className="font-[Montserrat,_sans-serif] text-[#508865]" style={{
              WebkitTextStrokeWidth: '0px',
              WebkitTextStrokeColor: '#508865',
              WebkitTextFillColor: '#508865'
            }} data-id="element-2200" data-mp="aukv4ac6cbr4">
                We're the driver.
              </span>{' '}
              <span className="font-[Montserrat,_sans-serif] text-[#085733]" data-id="element-2201" data-mp="2gnjj52h9ru5t">
                We're local.
              </span>
            </h2>
          </div>

          <div className="lg:col-span-6 lg:pl-6 lg:border-l lg:border-stone-200 dark:lg:border-white/10 pt-[10px] pb-[10px]" data-id="element-2202" data-mp="3ezdpdh73rptl">
            <p className="dark:text-stone-400 text-base md:text-lg leading-relaxed mb-4 text-stone-900 font-[400] font-[Inter,_sans-serif]" data-id="element-2203" data-mp="3szes726xh7bp">
              {"Built in the 253, we're on the road across the 206 and 425 daily, delivering gravel, soil, bark, and landscape materials throughout King and Pierce Counties.  Same trucks, same drivers, same dispatcher every load.  \nWhen you call, you're talking directly to the people who will schedule and deliver your materials\u2014giving you better service and dependable local delivery every time.."}
            </p>
            <Link to="/local-vs-national" className="group inline-flex items-center gap-2 text-brand-orange hover:text-brand-orange/80 font-bold text-sm tracking-tight transition-colors" data-id="element-2204" data-mp="phn1rs8fwvfm">
              <span className="font-[500] text-stone-700 dark:text-stone-400 group-hover:text-brand-orange transition-colors text-[18px] font-[Inter,_sans-serif]" data-id="element-2205" data-mp="144lqvgjtrdr6">
                See how we stack up vs. national marketplaces
              </span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1 shrink-0" data-id="element-2206" data-mp="v35j7gke9pqn" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}